import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from "../../../images/StudyCalculatorImg.webp";
const TITLE = "Kalkulator Nilai Skala 100 - Kalkulator IPK Universitas";
const DESCRIPTION =
  "Hitung IPK universitas Anda dengan akurat menggunakan kalkulator IPK universitas. Pelajari cara menghitung nilai dari skala 100 poin dengan mudah dan ketahui status kinerja akademik Anda.";
const KEYWORDS =
  "hitung nilai skala 100, kalkulator IPK universitas, hitung IPK universitas, kinerja akademik";
const OG_URL = "https://do-calculate.com/calculator/id/grade100";
function WeightedGradeCalculator() {
  const [assignments, setAssignments] = useState([
    { name: "Mata Kuliah 1", grade: "90", weight: "100" },
    { name: "Mata Kuliah 2", grade: "80", weight: "100" },
    { name: "Mata Kuliah 3 ", grade: "70", weight: "100" },
  ]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [weightedScore, setWeightedScore] = useState(0);
  const [weightedGrade, setWeightedGrade] = useState("");
  const [weightedGPA, setWeightedGPA] = useState(0);
  const calculateWeightedGrade = () => {
    setIsLoading(true);
    setError(null);
    let totalWeightedScore = 0;
    let totalWeight = 0;
    for (const assignment of assignments) {
      const grade = parseFloat(assignment.grade);
      const weight = parseFloat(assignment.weight);
      if (!isNaN(grade) && !isNaN(weight)) {
        totalWeightedScore += (grade / 100) * weight;
        totalWeight += weight;
      }
    }
    if (totalWeight === 0) {
      setError("Harap masukkan nilai yang valid untuk tugas dan bobot.");
    } else {
      const calculatedWeightedScore = (totalWeightedScore / totalWeight) * 100;
      setWeightedScore(calculatedWeightedScore.toFixed(2));
      const calculatedWeightedGrade = calculateWeightedGradeLetter(
        calculatedWeightedScore
      );
      setWeightedGrade(calculatedWeightedGrade);
      const calculatedWeightedGPA = calculateWeightedGPA(
        calculatedWeightedScore
      );
      setWeightedGPA(calculatedWeightedGPA.toFixed(2));
    }
    setIsLoading(false);
  };
  const calculateWeightedGradeLetter = (weightedScore) => {
    if (weightedScore >= 90) {
      return "A";
    } else if (weightedScore >= 80) {
      return "B";
    } else if (weightedScore >= 70) {
      return "C";
    } else if (weightedScore >= 60) {
      return "D";
    } else {
      return "F";
    }
  };
  const calculateWeightedGPA = (weightedScore) => {
    if (weightedScore >= 90) {
      return 4.0;
    } else if (weightedScore >= 80) {
      return 3.0;
    } else if (weightedScore >= 70) {
      return 2.0;
    } else if (weightedScore >= 60) {
      return 1.0;
    } else {
      return 0.0;
    }
  };
  const addAssignment = () => {
    setAssignments([...assignments, { name: "", grade: "", weight: 100 }]);
  };
  const removeAssignment = (index) => {
    const updatedAssignments = [...assignments];
    updatedAssignments.splice(index, 1);
    setAssignments(updatedAssignments);
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedAssignments = [...assignments];
    updatedAssignments[index][name] =
      name === "weight" && value === "" ? "100" : value;
    setAssignments(updatedAssignments);
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Hitung IPK Universitas Skala 100
                  </h2>
                </div>
                <hr />
                <div className="form-group d-flex align-items-center text-center">
                  <div style={{ width: "100%", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="assignment">Tugas/Ujian</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="grade">Nilai</label>
                    </b>
                  </div>

                    <div style={{ width: '75px', marginLeft: '4px', display: 'inline-block' }}>
                      <b><label>Bobot</label></b>
                      <button
                        type="button"
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: '0',
                          cursor: 'help',
                          marginLeft: '5px'
                        }}
                        title="Biarkan kolom bobot kosong jika mata kuliah Anda tidak memiliki bobot. Nilai default adalah 100%"
                      >
                        ℹ️
                      </button>
                    </div>
                  </div>
                {assignments.map((assignment, index) => (
                  <div key={index}>
                    <div className="form-group d-flex align-items-center">
                      <input
                        type="text"
                        name="name"
                        id="assignment"
                        placeholder="Mata Kuliah/Ujian"
                        value={assignment.name}
                        style={{ width: "100%", marginLeft: "4px" }}
                        className="form-control ml-2"
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="grade"
                        id="grade"
                        placeholder="75"
                        value={assignment.grade}
                        className="form-control ml-2"
                        style={{ width: "75px", marginLeft: "4px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="weight"
                        id="weight"
                        placeholder="100"
                        value={assignment.weight}
                        className="form-control ml-2"
                        style={{ width: "75px", marginLeft: "2px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <span
                        className="input-group-text "
                        style={{ marginLeft: "4px" }}
                      >
                        %
                      </span>
                      <button
                        className="text-white btn bg-secondary"
                        onClick={() => removeAssignment(index)}
                      >
                        Hapus
                      </button>
                    </div>
                    <div>
                      <br />
                    </div>
                  </div>
                ))}
                <button
                  className="text-white btn bg-success"
                  onClick={addAssignment}
                >
                  Tambah Mata Kuliah/Ujian
                </button>
                <div>
                  <br />
                </div>
                <button
                  className="text-white btn bg-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateWeightedGrade}
                  disabled={isLoading}
                >
                  Hitung
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-7">
                <br />
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Terjadi Kesalahan:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {weightedScore > 0 && (
                  <div className="bg-light bg-gradient text-dark">
                    <div className="p-3 mb-2 bg-success bg-gradient text-white">
                      <strong>Hasil</strong>
                    </div>
                    <b>Nilai Tertimbang (dari 100):</b> {weightedScore}%
                    <br />
                    <b>Nilai Tertimbang:</b> {weightedGrade}
                    <br />
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                  </u>
                  <p>
                    Untuk menghitung rata-rata tertimbang untuk tahun universitas, unit studi, atau tugas Anda, kami mengalikan nilai (atau angka) dengan bobot yang sesuai, menjumlahkannya, lalu membagi total dengan jumlah bobot. Berikut adalah contoh dan perhitungan ditampilkan di bagian bawah hasil.
                  </p>
                  <table >
                    <tbody>
                      <tr className="gpa-header">
                        <th>Nilai</th>
                        <th>Bobot</th>
                        <th>Unit</th>
                       </tr>
                       <tr>
                        <td>66%</td>
                        <td>20 SKS</td>
                        <td>Analisis Data</td>
                       </tr>
                       <tr>
                        <td>55%</td>
                        <td>10 SKS</td>
                        <td>Basis Data</td>
                       </tr>
                       <tr>
                        <td>71%</td>
                        <td>10 SKS</td>
                        <td>Desain Eksperimen</td>
                       </tr>
                    </tbody>
                   </table>
                  <p>
                    Rata-rata = (66 × 20 + 55 × 10 + 71 × 10) / (20 + 10 + 10)
                  </p>
                  <p>
                    Berdasarkan ini, nilai rata-rata untuk siswa A dihitung pada 64,5%.
                  </p>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Mata Kuliah Tidak Tertimbang</h2>
                  </u>
                  <p>
                    Jika Anda ingin melakukan perhitungan tidak tertimbang, cukup kosongkan semua kolom bobot, atau buat bobotnya sama. Jika Anda ingin mengetahui nilai yang Anda butuhkan dalam ujian akhir.
                  </p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default WeightedGradeCalculator;